export function getGridActionCellElement(event) {
  const clickedElement = event?.event?.currentTarget;
  const clickedCell = clickedElement?.closest?.('td');

  return (
    clickedCell ||
    event?.row?.cells?.find((cell) => cell.column === event.column)
      ?.cellElement ||
    event?.row?.cells?.find(
      (cell) => cell.column?.type === 'buttons'
    )?.cellElement
  );
}
